module.exports = __webpack_public_path__ + "static/media/TDSAT_white_logo.85972f84.png";